import axios from 'axios'


/**
 *
 * @status no delete
 * @class PlanService
 */
class PlanService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Leonel Contreras
  * @description Handle event to get the information about a plans asigned to Mifirma from A3cloud
  * @date 20-07-2020
  * @param {String} token
  * @returns {Object}
  * @memberof PlanService
  */
  async getPlanService(token) {
    let response = await axios.get(`${this.apiUrl}/plan-pricing`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
  * @author Alan Aguilar
  * @description Handle event to get the information a contract and plan of a user sesion from hibou.legal and A3cloud
  * @date 11-09-2020
  * @status no delete
  * @param {String} token
  * @returns {Object}
  * @memberof PlanService
  */
  async getUserContractAndPlan(token) {
    const resp = await axios.get(`${this.apiUrl}/plan-user-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then(function (response) {
      return response.data
    }).catch(function (error) {
      return { response: 'error', data: error }
    })
    return resp
  }
}

export { PlanService as default }
